module.exports = __webpack_public_path__ + "static/jfg-0d6ab598e177ad889ba15c5db7f5c570.png";